export default __webpack_public_path__ + "static/media/panel.31ec5068.svg";